import { Forms } from 'sites/types';
import { FormFieldConfig } from 'ui/forms/custom/types';

import { commonForms } from '../common/forms';

const addressForm: Array<Array<FormFieldConfig>> = [
  [
    { name: 'lastName', type: 'input', required: true, preventStack: true },
    { name: 'firstName', type: 'input', required: true, preventStack: true },
  ],
  [
    {
      name: 'lastNamePronunciation',
      type: 'input',
      required: false,
      preventStack: true,
    },
    {
      name: 'firstNamePronunciation',
      type: 'input',
      required: false,
      preventStack: true,
    },
  ],
  [
    { name: 'postalCode', type: 'yubinbango-address-look-up', required: true },
    { name: 'stateCode', type: 'input', required: true },
  ],
  [{ name: 'city', type: 'input', required: true }],
  [{ name: 'address1', type: 'input', required: true }],
];

export const JPForms: Forms = {
  ...commonForms,
  accountAddress: [
    [{ name: 'title', type: 'input', required: true }],
    ...addressForm,
    [{ name: 'phone', type: 'input', inputType: 'tel', required: true }],
    [{ name: 'preferred', type: 'checkbox' }],
  ],
  checkoutAddress: [
    ...addressForm,
    [{ name: 'phone', type: 'input', inputType: 'tel', required: true }],
    [{ name: 'addToAddressBook', type: 'checkbox' }],
  ],
  checkoutAmazonPayBillingAddress: [
    [
      { name: 'lastName', type: 'input', required: false, preventStack: true },
      { name: 'firstName', type: 'input', required: true, preventStack: true },
    ],
    ...addressForm.slice(1),
    [{ name: 'phone', type: 'input', inputType: 'tel', required: true }],
    [{ name: 'addToAddressBook', type: 'checkbox' }],
  ],
  checkoutAddressGuest: [
    ...addressForm,
    [{ name: 'phone', type: 'input', inputType: 'tel', required: true }],
  ],
  checkoutContactInfo: [
    [{ name: 'email', type: 'input', inputType: 'email', required: true }],
    [{ name: 'emailList', type: 'checkbox' }],
  ],
  createAccountInConfirmation: [
    [{ name: 'password', type: 'password', required: true }],
    [{ name: 'passwordConfirmation', type: 'password', required: true }],
    [
      {
        name: 'createAccountOnOrderConfirmation',
        type: 'button',
        buttonType: 'submit',
      },
      { name: 'blank', type: 'blank' },
    ],
  ],
  registration: [
    [
      { name: 'lastName', type: 'input', required: true, preventStack: true },
      { name: 'firstName', type: 'input', required: true, preventStack: true },
    ],
    [
      { name: 'lastNamePronunciation', type: 'input', preventStack: true },
      { name: 'firstNamePronunciation', type: 'input', preventStack: true },
    ],
    [{ name: 'birthday', type: 'birthday', required: true }],
    [{ name: 'email', type: 'input', inputType: 'email', required: true }],
    [{ name: 'password', type: 'password', required: true }],
    [{ name: 'emailList', type: 'checkbox' }],
    [{ name: 'tacOnCreateAccount', type: 'terms-and-conditions' }],
    [{ name: 'registerHere', type: 'button', buttonType: 'submit' }],
  ],
  registrationV2: [
    [
      { name: 'lastName', type: 'input', required: true, preventStack: true },
      { name: 'firstName', type: 'input', required: true, preventStack: true },
    ],
    [
      { name: 'lastNamePronunciation', type: 'input', preventStack: true },
      { name: 'firstNamePronunciation', type: 'input', preventStack: true },
    ],
    [{ name: 'birthday', type: 'birthday', required: true }],
    [{ name: 'email', type: 'input', inputType: 'email', required: true }],
    [{ name: 'password', type: 'password', required: true }],
    [{ name: 'emailList', type: 'checkbox' }],
    [{ name: 'tacOnCreateAccount', type: 'terms-and-conditions' }],
    [{ name: 'registerHere', type: 'button', buttonType: 'submit' }],
  ],
  quickRegistration: [
    [{ name: 'lastName', type: 'input', required: true }],
    [{ name: 'firstName', type: 'input', required: true }],
    [{ name: 'email', type: 'input', inputType: 'email', required: true }],
    [{ name: 'password', type: 'password', required: true }],
    [{ name: 'registrationHintText', type: 'text-only' }],
    [{ name: 'register', type: 'button', buttonType: 'submit' }],
    [{ name: 'emailList', type: 'checkbox' }],
  ],
  addPaymentMethod: [
    [{ name: 'holderNameAccount', type: 'input', required: true }],
    [{ name: 'cardNumber', type: 'card-number', required: true }],
    [
      { name: 'expirationDate', type: 'expiration-date', required: true },
      { name: 'cvv', type: 'cvv', required: true },
    ],
    [{ name: 'setStandardPayment', type: 'checkbox' }],
    [{ name: 'save', type: 'button', buttonType: 'submit' }],
  ],
  editProfile: [
    [{ name: 'lastName', type: 'input', required: true }],
    [{ name: 'firstName', type: 'input', required: true }],
    [{ name: 'lastNamePronunciation', type: 'input', required: true }],
    [{ name: 'firstNamePronunciation', type: 'input', required: true }],
    [{ name: 'gender', type: 'input-radio' }],
    [
      {
        name: 'birthday',
        type: 'birthday',
        required: true,
        hideSupportText: true,
      },
    ],
    [
      {
        name: 'save',
        type: 'button',
        buttonType: 'submit',
      },
    ],
  ],
  orderLookUpReturns: [
    [
      {
        name: 'orderNo',
        type: 'input',
        inputType: 'text',
        required: true,
      },
    ],
    [{ name: 'orderEmail', type: 'input', inputType: 'email', required: true }],
    [{ name: 'phone', type: 'input', inputType: 'tel', required: true }],
    [
      {
        name: 'returnsOrderExplainerModal',
        type: 'text-to-modal',
        required: true,
      },
    ],
    [
      {
        name: 'submitButton',
        type: 'button',
        buttonType: 'submit',
      },
    ],
  ],
  changePassword: [
    [{ name: 'currentPassword', type: 'password', required: true }],
    [{ name: 'newPassword', type: 'password', required: true }],
    [{ name: 'newPasswordConfirmation', type: 'password', required: true }],
    [
      {
        name: 'save',
        type: 'button',
        buttonType: 'submit',
      },
    ],
  ],
};
